export default __webpack_public_path__ + "static/media/undraw_share_link_re_54rx.279f1906.svg";